var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "105.000000pt",
    height: "105.000000pt",
    viewBox: "0 0 105.000000 105.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,105.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445 1020 c-199 -32 -370 -189 -414 -381 -16 -66 -13 -189 5 -250 93 -317 436 -461 728 -306 115 61 216 192 245 317 6 25 11 82 11 126 1 264 -197 476 -465 497 -33 3 -82 2 -110 -3z m255 -96 c119 -57 203 -152 240 -272 78 -253 -83 -515 -348 -564 -177 -33 -372 64 -458 228 -128 241 -18 522 241 621 51 20 76 23 160 20 88 -2 108 -6 165 -33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490 781 c-51 -16 -87 -41 -128 -85 -23 -25 -42 -50 -42 -56 0 -5 -11 -10 -24 -10 -33 0 -53 -25 -36 -45 7 -8 18 -15 24 -15 18 0 12 -94 -7 -98 -40 -8 -24 -62 19 -62 15 0 28 -9 38 -27 38 -74 127 -122 223 -123 81 0 115 13 111 43 -3 21 -7 22 -74 19 -81 -4 -141 16 -183 62 l-24 26 89 0 c96 0 118 7 112 36 -3 17 -16 20 -113 24 l-110 5 -3 47 -3 47 113 3 113 3 0 25 c0 25 -1 25 -99 30 l-98 5 25 27 c50 54 126 73 221 56 28 -5 45 28 24 48 -18 18 -128 28 -168 15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingIcon);
export default __webpack_public_path__ + "static/media/pricing-icon.2f71a78989e5c00792ecfce27cabd6f6.svg";
export { ForwardRef as ReactComponent };